import { useEffect, useCallback } from 'react';
import { useColorMode } from '@antimatterhq/ui/contexts/ColorModeContext';
import { useConfig } from '@/contexts/ConfigContext';

export function useClientColorModeSync() {
  const { colorMode } = useColorMode();
  const { IFRAME_URL } = useConfig();

  const syncColorMode = useCallback(() => {
    const iframe = document.getElementById('dasl-iframe') as HTMLIFrameElement;
    if (iframe) {
      iframe.contentWindow?.postMessage({ colorMode }, IFRAME_URL);
    }
  }, [colorMode, IFRAME_URL]);

  useEffect(() => {
    syncColorMode();
  }, [colorMode, IFRAME_URL, syncColorMode]);

  return syncColorMode;
}
